// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Category-AssignToItemModal-Search-__style___3p-4P","right":"app-pages-Library-Category-AssignToItemModal-Search-__style___3NupD"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Category/AssignToItemModal/Search/style.css
// module id = 2150
// module chunks = 0